import styled from 'styled-components';

const DivDetailPageBody = styled.div`
  line-height: 1.5;
  margin-top: 36px;
  font-size: 18px;
`;

export default DivDetailPageBody;
